import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={176}
    height={159}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    {...props}
  >
    <path
      fill="#fff"
      d="M130.807 118.203v.394l-22.882-13.211a8.225 8.225 0 0 0-8.222 0L42.01 137.539h-1.826l.031 3.608a2.255 2.255 0 0 0 1.104 1.875l24.425 14.735a7.276 7.276 0 0 0 7.407.067l58.255-33.632a3.007 3.007 0 0 0 1.517-2.628v-3.361h-2.116Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <g opacity={0.8}>
      <mask
        id="a"
        width={95}
        height={56}
        x={39}
        y={104}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M133.127 104.085h-93.14v54.917h93.14v-54.917Z" />
      </mask>
      <g mask="url(#a)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
          d="M130.807 118.203v.394l-22.882-13.211a8.225 8.225 0 0 0-8.222 0L42.01 137.539h-1.826l.031 3.608a2.255 2.255 0 0 0 1.104 1.875l24.425 14.735a7.276 7.276 0 0 0 7.407.067l58.255-33.632a3.007 3.007 0 0 0 1.517-2.628v-3.361h-2.116Z"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m99.71 102.006-58.347 33.688c-1.512.87-1.53 3.047-.038 3.948l24.425 14.735a7.292 7.292 0 0 0 7.407.074l58.255-33.633c2.023-1.166 2.023-4.083 0-5.249l-23.481-13.557a8.224 8.224 0 0 0-8.221 0"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m99.71 102.006-58.347 33.688c-1.512.87-1.53 3.047-.038 3.948l24.425 14.735a7.292 7.292 0 0 0 7.407.074l58.255-33.633c2.023-1.166 2.023-4.083 0-5.249l-23.481-13.557a8.224 8.224 0 0 0-8.221 0v-.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m126.897 114.366 3.898 2.251c.561.327.901.907.901 1.561 0 .654-.34 1.234-.901 1.56l-58.254 33.633a6.067 6.067 0 0 1-3.029.814 6.186 6.186 0 0 1-3.127-.869l-24.424-14.735a1.044 1.044 0 0 1-.512-.919c0-.185.055-.635.53-.907l58.347-33.688a7.021 7.021 0 0 1 3.498-.938c1.227 0 2.43.327 3.49.938l3.646 2.103"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m126.897 114.366 3.898 2.251c.561.327.901.907.901 1.561 0 .654-.34 1.234-.901 1.56l-58.254 33.633a6.067 6.067 0 0 1-3.029.814 6.186 6.186 0 0 1-3.127-.869l-24.424-14.735a1.044 1.044 0 0 1-.512-.919c0-.185.055-.635.53-.907l58.347-33.688a7.021 7.021 0 0 1 3.498-.938c1.227 0 2.43.327 3.49.938l3.646 2.103"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m110.96 105.164-.334.444a.977.977 0 0 0 .259 1.468l12.897 7.5a2.294 2.294 0 0 0 1.925.173l1.19-.389"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m110.96 105.164-.334.444a.977.977 0 0 0 .259 1.468l12.897 7.5a2.294 2.294 0 0 0 1.925.173l1.19-.389"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m119.773 110.838-4.915-2.843a.217.217 0 0 1-.013-.364.217.217 0 0 1 .228-.006l4.916 2.843a.216.216 0 0 1 .012.364.215.215 0 0 1-.228.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m119.773 110.838-4.915-2.843a.217.217 0 0 1-.013-.364.217.217 0 0 1 .228-.006l4.916 2.843a.216.216 0 0 1 .012.364.215.215 0 0 1-.228.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m122.438 112.386-1.524-.894a.216.216 0 0 1-.012-.364.217.217 0 0 1 .228-.006l1.524.894a.217.217 0 0 1 .012.364.215.215 0 0 1-.228.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m122.438 112.386-1.524-.894a.216.216 0 0 1-.012-.364.217.217 0 0 1 .228-.006l1.524.894a.217.217 0 0 1 .012.364.215.215 0 0 1-.228.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m125.127 126.319-3.121 1.801a.227.227 0 0 1-.228-.394l3.121-1.801a.225.225 0 0 1 .339.197c0 .08-.043.154-.111.197Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m125.127 126.319-3.121 1.801a.227.227 0 0 1-.228-.394l3.121-1.801a.225.225 0 0 1 .339.197c0 .08-.043.154-.111.197Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m107.962 136.503-3.121 1.8a.227.227 0 0 1-.228-.394l3.121-1.801a.225.225 0 0 1 .339.197c0 .08-.043.154-.111.198Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m107.962 136.503-3.121 1.8a.227.227 0 0 1-.228-.394l3.121-1.801a.225.225 0 0 1 .339.197c0 .08-.043.154-.111.198Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m55.678 150.676-4.947-2.856a.248.248 0 0 1-.123-.216v-.962c0-.105.111-.172.204-.117l4.915 2.837a.28.28 0 0 1 .142.253v.95c0 .099-.105.16-.191.111Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m55.678 150.676-4.947-2.856a.248.248 0 0 1-.123-.216v-.962c0-.105.111-.172.204-.117l4.915 2.837a.28.28 0 0 1 .142.253v.95c0 .099-.105.16-.191.111Z"
    />
    <g opacity={0.15}>
      <mask
        id="b"
        width={6}
        height={5}
        x={50}
        y={146}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M55.875 146.506h-5.26v3.652h5.26v-3.652Z" />
      </mask>
      <g mask="url(#b)">
        <path
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          fill="#fff"
          d="m55.727 149.362-4.915-2.837a.134.134 0 0 0-.204.117v.962c0 .074.03.142.086.186l.512-.383 4.663 2.745v-.543a.301.301 0 0 0-.142-.253"
        />
      </g>
    </g>
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m55.727 149.362-4.915-2.837a.134.134 0 0 0-.204.117v.962c0 .074.03.142.086.186l.512-.383 4.663 2.745v-.543a.301.301 0 0 0-.142-.253v.006Z"
    />

    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m97.785 74.597-13.73-9.523a1.132 1.132 0 0 0-1.208-.056l-5.94 2.739 4.663 5.785-.962 10.466a1.14 1.14 0 0 0 .493 1.05l7.081 4.828 2.985 8.278 6.063-2.776s.013 0 .019-.006l.037-.019c.326-.172.573-.493.61-.906l1.511-16.4a3.78 3.78 0 0 0-1.61-3.454"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m97.785 74.597-13.73-9.523a1.132 1.132 0 0 0-1.208-.056l-5.94 2.739 4.663 5.785-.962 10.466a1.14 1.14 0 0 0 .493 1.05l7.081 4.828 2.985 8.278 6.063-2.776s.013 0 .019-.006l.037-.019c.326-.172.573-.493.61-.906l1.511-16.4a3.78 3.78 0 0 0-1.61-3.454l-.012-.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m76.352 68.638-1.665 18.103a1.14 1.14 0 0 0 .493 1.048l15.013 10.233a1.14 1.14 0 0 0 1.776-.84l1.598-17.368a2.11 2.11 0 0 0-.901-1.93L78.135 67.806a1.138 1.138 0 0 0-1.783.832Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m76.352 68.638-1.665 18.103a1.14 1.14 0 0 0 .493 1.048l15.013 10.233a1.14 1.14 0 0 0 1.776-.84l1.598-17.368a2.11 2.11 0 0 0-.901-1.93L78.135 67.806a1.138 1.138 0 0 0-1.783.832Z"
    />
    <path
      fill="#fff"
      d="M87.861 81.393c1.135 3.27.198 6.57-2.097 7.365-2.294.795-5.076-1.21-6.21-4.478-1.136-3.269-.198-6.569 2.096-7.364 2.295-.796 5.076 1.209 6.211 4.477Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M87.861 81.393c1.135 3.27.198 6.57-2.097 7.365-2.294.795-5.076-1.21-6.21-4.478-1.136-3.269-.198-6.569 2.096-7.364 2.295-.796 5.076 1.209 6.211 4.477Z"
    />
    <path
      fill="#fff"
      d="M93.363 75.886a1.903 1.903 0 0 1-1.72-2.073l.968-10.534c.16-1.734-.266-3.183-1.074-3.701-1.196-.765-2.51-.993-3.343-.586-.93.457-1.233 1.72-1.326 2.695l-.549 5.99a1.912 1.912 0 0 1-2.072 1.726 1.903 1.903 0 0 1-1.72-2.072l.548-5.99c.34-3.718 2.307-5.21 3.442-5.772 2.066-1.012 4.706-.716 7.074.79 2.066 1.313 3.121 4.033 2.825 7.265l-.968 10.535a1.903 1.903 0 0 1-2.073 1.72"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M93.363 75.886a1.903 1.903 0 0 1-1.72-2.073l.968-10.534c.16-1.734-.266-3.183-1.074-3.701-1.196-.765-2.51-.993-3.343-.586-.93.457-1.233 1.72-1.326 2.695l-.549 5.99a1.912 1.912 0 0 1-2.072 1.726 1.903 1.903 0 0 1-1.72-2.072l.548-5.99c.34-3.718 2.307-5.21 3.442-5.772 2.066-1.012 4.706-.716 7.074.79 2.066 1.313 3.121 4.033 2.825 7.265l-.968 10.535a1.903 1.903 0 0 1-2.073 1.72l-.012.007Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#E5E5E5"
      d="M84.827 82.818c.061-.66-.518-1.572-1.258-1.961-.58-.302-1.086-.148-1.172.352-.08.431.148.993.524 1.449l-.148 1.616c-.012.16.111.376.29.481l.567.352c.173.105.327.067.34-.093l.148-1.616c.388.043.678-.166.715-.586"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M84.827 82.818c.061-.66-.518-1.572-1.258-1.961-.58-.302-1.086-.148-1.172.352-.08.431.148.993.524 1.449l-.148 1.616c-.012.16.111.376.29.481l.567.352c.173.105.327.067.34-.093l.148-1.616c.388.043.678-.166.715-.586l-.006.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m128.982 92.619-18.244 20.927c-1.024 1.172-2.332.746-2.912-.956l-4.699-13.723c-.586-1.703-.229-4.04.795-5.212l18.244-20.927c1.024-1.178 2.332-.747 2.912.956l4.699 13.723c.586 1.702.229 4.034-.795 5.212Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m128.982 92.619-18.244 20.927c-1.024 1.172-2.332.746-2.912-.956l-4.699-13.723c-.586-1.703-.229-4.04.795-5.212l18.244-20.927c1.024-1.178 2.332-.747 2.912.956l4.699 13.723c.586 1.702.229 4.034-.795 5.212Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m130.4 93.106-18.244 20.927c-1.024 1.172-2.331.746-2.911-.956l-4.7-13.723c-.586-1.703-.228-4.04.796-5.212l18.244-20.927c1.024-1.178 2.331-.746 2.911.956l4.7 13.723c.586 1.702.228 4.034-.796 5.212Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m130.4 93.106-18.244 20.927c-1.024 1.172-2.331.746-2.911-.956l-4.7-13.723c-.586-1.703-.228-4.04.796-5.212l18.244-20.927c1.024-1.178 2.331-.746 2.911.956l4.7 13.723c.586 1.702.228 4.034-.796 5.212Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#E5E5E5"
      d="m116.122 97.596-5.421 6.224c-.66-1.931-.26-4.577.906-5.91l1.215-1.393c1.16-1.332 2.64-.845 3.3 1.086"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.352}
      d="m116.122 97.596-5.421 6.224c-.66-1.931-.26-4.577.906-5.91l1.215-1.393c1.16-1.332 2.64-.845 3.3 1.086v-.007Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#E5E5E5"
      d="M113.032 93.834c.333.968-.037 2.48-.82 3.38-.784.9-1.69.845-2.023-.117-.333-.969.037-2.48.82-3.38.783-.901 1.69-.846 2.017.117"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.352}
      d="M113.032 93.834c.333.968-.037 2.48-.82 3.38-.784.9-1.69.845-2.023-.117-.333-.969.037-2.48.82-3.38.783-.901 1.69-.846 2.017.117h.006ZM118.712 94.697l-11.311 12.977M111.138 107.656l5.878-6.748M112.033 110.265l5.878-6.748M114.87 83.528l6.741 19.681M125.843 84.477c.536 1.567-.062 4.015-1.333 5.477-1.27 1.456-2.738 1.37-3.275-.191-.536-1.567.062-4.015 1.332-5.477 1.271-1.456 2.739-1.37 3.276.191Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m44.261 47.273 15.987-5.255a.694.694 0 0 1 .66.124l.013-.019 6.303 5.65-3.17 2.584-3.127.481L55.77 68.78a1.404 1.404 0 0 1-.943 1.049l-5.94 1.9-1.986 5.267-2.572 3.602-6.254-5.644a.648.648 0 0 1-.308-.703l5.575-25.942c.105-.487.457-.881.932-1.036"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m44.261 47.273 15.987-5.255a.694.694 0 0 1 .66.124l.013-.019 6.303 5.65-3.17 2.584-3.127.481L55.77 68.78a1.404 1.404 0 0 1-.943 1.049l-5.94 1.9-1.986 5.267-2.572 3.602-6.254-5.644a.648.648 0 0 1-.308-.703l5.575-25.942c.105-.487.457-.881.932-1.036h-.013Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m49.819 53.527-6.236-5.273c-.13-.117-.222.025-.253.197l-5.6 26.053 6.488 5.927 5.6-26.904Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m49.819 53.527-6.236-5.273c-.13-.117-.222.025-.253.197l-5.6 26.053 6.488 5.927 5.6-26.904Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m66.62 47.724-15.987 5.255a1.393 1.393 0 0 0-.932 1.036l-5.575 25.941c-.105.5.364.925.85.771l16.21-5.187c.48-.154.845-.555.943-1.048l5.397-25.954a.705.705 0 0 0-.913-.814"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m66.62 47.724-15.987 5.255a1.393 1.393 0 0 0-.932 1.036l-5.575 25.941c-.105.5.364.925.85.771l16.21-5.187c.48-.154.845-.555.943-1.048l5.397-25.954a.705.705 0 0 0-.913-.814h.007ZM58.971 50.351l-5.933 27.632"
    />
    <path
      fill="#E5E5E5"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M53.556 66.245a.546.546 0 0 1-.438-.21.569.569 0 0 1-.11-.474l.58-2.702a.57.57 0 0 1 .554-.444c.173 0 .333.074.438.21a.569.569 0 0 1 .111.475l-.58 2.701a.55.55 0 0 1-.388.42.52.52 0 0 1-.167.024Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M54.142 62.613c.222 0 .407.203.358.438l-.58 2.701a.357.357 0 0 1-.247.272.343.343 0 0 1-.105.018.365.365 0 0 1-.357-.438l.58-2.701a.35.35 0 0 1 .24-.266.386.386 0 0 1 .117-.018m-.006-.407a.767.767 0 0 0-.752.605l-.58 2.7a.751.751 0 0 0 .154.642.773.773 0 0 0 .827.247.763.763 0 0 0 .524-.574l.58-2.701a.751.751 0 0 0-.155-.642.773.773 0 0 0-.598-.283"
    />
    <path
      fill="#E5E5E5"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M58.034 65.024a.547.547 0 0 1-.438-.21.568.568 0 0 1-.11-.474l.579-2.702a.558.558 0 0 1 .37-.413.555.555 0 0 1 .623.179.569.569 0 0 1 .11.474l-.579 2.702a.55.55 0 0 1-.388.42.52.52 0 0 1-.167.024Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M58.614 61.392c.222 0 .407.203.358.437l-.58 2.702a.357.357 0 0 1-.247.271.343.343 0 0 1-.105.019.365.365 0 0 1-.358-.438l.58-2.702a.35.35 0 0 1 .24-.265.388.388 0 0 1 .118-.018m-.006-.408a.767.767 0 0 0-.752.605l-.58 2.701a.751.751 0 0 0 .154.642.773.773 0 0 0 .826.247.763.763 0 0 0 .524-.574l.58-2.702a.751.751 0 0 0-.154-.64.773.773 0 0 0-.598-.285M84.981 129.854l-16.437-30.9a1.133 1.133 0 0 0-.95-.6l-19.416-.77c-.358-.013-1.184 1.24-1.018 1.554l16.468 31.043c.05.086.722-.722.82-.722l19.929 1.69c.216.006.709-1.11.604-1.302"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m84.981 129.854-16.437-30.9a1.133 1.133 0 0 0-.95-.6l-19.416-.77c-.358-.013-1.184 1.24-1.018 1.554l16.468 31.043c.05.086.722-.722.82-.722l19.929 1.69c.216.006.709-1.11.604-1.302v.007Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m84.45 130.89-16.437-30.9a1.133 1.133 0 0 0-.95-.599l-19.416-.771a.47.47 0 0 0-.431.685l16.468 31.042c.049.086.135.148.24.148l20.268.802a.278.278 0 0 0 .259-.413"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m84.45 130.89-16.437-30.9a1.133 1.133 0 0 0-.95-.599l-19.416-.771a.47.47 0 0 0-.431.685l16.468 31.042c.049.086.135.148.24.148l20.268.802a.278.278 0 0 0 .259-.413v.006Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M60.075 116.834a.444.444 0 0 0 .235-.377.444.444 0 0 0-.432-.462l-1.221-.044a.445.445 0 0 0-.839-.277l-.253.506a.435.435 0 0 0 .019.425c.08.13.216.21.37.216l1.893.068c.08 0 .16-.018.228-.049"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M60.075 116.834a.444.444 0 0 0 .235-.377.444.444 0 0 0-.432-.462l-1.221-.044a.445.445 0 0 0-.839-.277l-.253.506a.435.435 0 0 0 .019.425c.08.13.216.21.37.216l1.893.068c.08 0 .16-.018.228-.049v-.006Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M91.18 44.695s19.687 3.947 27.816 5.126c.586.086 3.46-.272 5.385-2.474 1.381-1.579 3.928-4.163 5.131-5.933 1.585-2.331.716-5.576-1.869-6.71a2.802 2.802 0 0 0-.24-.1c-3.911-1.554-8.684-2.738-8.684-2.738s-6.304-4.034-7.969-4.49c0 0-5.187-2.066-10.8-1.807-3.72.173-7.66 3.25-10.374 6.741-3.972 4.675-2.745 7.488-1.863 9.474a5.01 5.01 0 0 0 1.906 2.202c.438.277.975.549 1.548.703"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M91.18 44.695s19.687 3.947 27.816 5.126c.586.086 3.46-.272 5.385-2.474 1.381-1.579 3.928-4.163 5.131-5.933 1.585-2.331.716-5.576-1.869-6.71a2.802 2.802 0 0 0-.24-.1c-3.911-1.554-8.684-2.738-8.684-2.738s-6.304-4.034-7.969-4.49c0 0-5.187-2.066-10.8-1.807-3.72.173-7.66 3.25-10.374 6.741-3.972 4.675-2.745 7.488-1.863 9.474a5.01 5.01 0 0 0 1.906 2.202c.438.277.975.549 1.548.703l.013.006Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      fill="#fff"
      d="m90.032 38.059 19.275 3.731s-4.7-6.451-10.856-7.457c-7.506-1.227-8.412 2.85-8.511 3.59a.122.122 0 0 0 .099.136"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m90.032 38.059 19.275 3.731s-4.7-6.451-10.856-7.457c-7.506-1.227-8.412 2.85-8.511 3.59a.122.122 0 0 0 .099.136h-.007Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M109.301 41.79c1.504-.561 7.29-5.502 9.319-9.918M103.059 36.097c2.004-1.16 6.044-5.65 7.913-8.628M98.649 25.73c-1.838 1.023-3.756 3.428-6.125 6.574-1.085 1.45-3.984 2.375-4.687 2.615"
    />
    <path
      fill="#E5E5E5"
      d="M111.04 50.32c1.202 1.08 2.806 1.258 3.577.401.771-.863.426-2.436-.783-3.515-1.203-1.08-2.807-1.259-3.578-.401-.77.863-.425 2.436.784 3.515ZM91.945 46.879c1.208 1.079 2.806 1.252 3.577.388.77-.863.413-2.436-.79-3.51-1.202-1.072-2.806-1.251-3.577-.388-.771.864-.413 2.436.79 3.51Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M129.469 36.171a4.59 4.59 0 0 1-.703 3.498c-1.197 1.77-3.75 4.354-5.126 5.933-1.93 2.202-4.792 2.523-5.384 2.473a17.54 17.54 0 0 1-1.073-.136c-.814-.123-1.579-.5-2.134-1.103a4.938 4.938 0 0 0-.401-.395c-1.727-1.555-4.028-1.808-5.138-.574-.284.32-.709.457-1.116.37-3.621-.765-7.611-1.647-10.985-2.4-.555-.123-1.03-.443-1.394-.881a5.835 5.835 0 0 0-.604-.635c-1.727-1.555-4.028-1.807-5.138-.574-.037.037-.068.08-.099.117a.568.568 0 0 1-.573.198s-.025-.006-.037-.013c-.568-.154-1.092-.425-1.53-.697a5.127 5.127 0 0 1-.598-.438"
    />
    <defs>
      <linearGradient
        id="e"
        x1={86.966}
        x2={90.253}
        y1={76.331}
        y2={242.94}
        gradientUnits="userSpaceOnUse"
        shapeRendering="geometricPrecision"
        vectorEffect="non-scaling-stroke"
      >
        <stop
          stopColor="#C4C4C4"
          stopOpacity={0}
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
        <stop
          offset={0.9}
          stopColor="#C4C4C4"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
        <stop
          offset={1}
          stopColor="#C4C4C4"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
